import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { ServiceInformationProps } from '@/modules/Service/types'
import {
    createDeviceLiquidationColumns,
    type DeviceLiquidationRow,
} from './device-liquidation-config'

const Information: React.FC<ServiceInformationProps> = ({ service }) => {
    const { t } = useTranslation()

    // Create columns
    const columns = useMemo(() => {
        return createDeviceLiquidationColumns(t)
    }, [t])

    // Create row data
    const rows = useMemo<DeviceLiquidationRow[]>(() => [service], [service])

    return (
        <DataTableCustomized<DeviceLiquidationRow>
            columns={columns}
            rows={rows}
            rowKey={(row) => String(row?.service_id)}
            size="small"
            resizable
            emptyMessage={t('no-data', { defaultValue: 'No data' })}
        />
    )
}

export default Information
